import script from "./Board.vue?vue&type=script&setup=true&lang=js"
export * from "./Board.vue?vue&type=script&setup=true&lang=js"

import "./Board.vue?vue&type=style&index=0&id=281a3b26&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-281a3b26"]])

export default __exports__